<template>
  <modal name="charge-modal" width="280px" height="130px" class="charge-modal" :pivotY="0.5" :clickToClose="false">
    <div class="title">请确认是否支付完成</div>
    <div class="confirm" @click="confirm">我已支付</div>
    <div class="cancel" @click="cancel">取消</div>
  </modal>
</template>

<script>
export default {
  methods: {
    cancel() {
      this.$modal.hide('charge-modal');
      this.$emit('cancel');
    },
    confirm() {
      this.$emit('confirm');
    }
  }
}
</script>

<style lang="scss">
.charge-modal {
  .v--modal {
    border-radius: 10px;
  }
}
</style>

<style lang="scss" scoped>
.charge-modal {
  .title {
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #f0f0f0;
    text-align: center;
    line-height: 50px;
    color: #333;
  }
  .confirm {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #f0f0f0;
    text-align: center;
    line-height: 40px;
    color: #09BB07;
  }
  .cancel {
    width: 100%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    color: #9A9C9C;
  }
}
</style>



